import { useQuery } from '@tanstack/react-query'
import { regionService } from '@/lib/api/services/region'

// Query keys factory
export const regionKeys = {
  all: ['regions'] as const,
  lists: () => [...regionKeys.all, 'list'] as const,
  allRegions: () => [...regionKeys.lists(), 'all'] as const,
}

/**
 * Hook to fetch all regions
 */
export const useAllRegions = () => {
  return useQuery({
    queryKey: regionKeys.allRegions(),
    queryFn: () => regionService.getAllRegions(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

